import { redirectToBackofficeV1 } from '@/utils/backoffice-v1';

export const redirectToPaymentMethodsPage = (brandId: string, restaurantId: string): void => {
    const customerDetailsPagePath = `/home/brands/${brandId}/restaurants/${restaurantId}/payment`;
    redirectToBackofficeV1(customerDetailsPagePath);
};
